import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled from 'styled-components';
import { get } from '../../styles/constant';
import Select from 'react-select';
import { variant } from 'styled-system';
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), props => props.width ? "".concat(props.width, "%") : '100%');
const Label = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 0 ", " 0;\n  & span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n"])), get('space.4'), get('colors.feedback.danger.normal'));
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      minHeight: get('space.32'),
      fontSize: get('fontSizes.s'),
      borderRadius: get('borderRadius.s'),
      padding: "".concat(get('space.0'), " ").concat(get('space.8'))
    },
    medium: {
      minHeight: get('space.40'),
      fontSize: get('fontSizes.m'),
      borderRadius: get('borderRadius.m'),
      padding: "".concat(get('space.0'), " ").concat(get('space.12'))
    },
    large: {
      minHeight: get('space.48'),
      fontSize: get('fontSizes.l'),
      borderRadius: get('borderRadius.m'),
      padding: "".concat(get('space.0'), " ").concat(get('space.16'))
    }
  }
});
const variants = {
  fit
};
const StyledSelect = styled(Select)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .MultiSelect__control {\n    ", "\n  }\n"])), variants.fit);
const LabelContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
const LabelTooltip = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), get('space.4'));
const Components = {
  Wrapper,
  Label,
  StyledSelect,
  LabelContent,
  LabelTooltip
};
export { Components };